interface String {
    format(...replacements: string[]): string
}
// eslint-disable-next-line no-extend-native
String.prototype.format = function (): string {
    const args = arguments;
    return this.replace(/{(\d+)}/g, (match: any, index: number) => {
        return typeof args[index] !== 'undefined' ? args[index] : match;
    });
}